import React from 'react';
import moment from 'moment';
import MaterialUIDatePicker from 'material-ui/DatePicker';
import formatDate from 'utils/formatDate';
import './DatePicker.styl';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';

// material ui returns the event first. in this case always null
const onChangeWrapper = onChange => (_, value) => onChange(moment(value));
const convertedProps = ['value', 'maxDate', 'minDate'];

export default class DatePicker extends React.PureComponent {
  render() {
    // what does this even do TODO replace with something readable
    const props = convertedProps.reduce(
      (props, prop) => ({
        ...props,
        [prop]: props[prop] ? props[prop].toDate() : undefined,
      }),
      this.props
    );
    return (
      <div className="date-picker" onClick={() => this.dialogWindow && this.dialogWindow.show()}>
        <MaterialUIDatePicker
          formatDate={date => formatDate(moment(date))}
          {...props}
          onChange={onChangeWrapper(this.props.onChange)}
          className="date-picker-input"
          ref={component => component && (this.dialogWindow = component.refs.dialogWindow)}
        />
        <CalendarDaysIcon />
      </div>
    );
  }
}
